import * as PropTypes from "prop-types";

export const DISCOUNT_MAIN_TYPES = {
  custom: "custom",
  freeFill: "freeFill",
  lowesIME: "lowesIME",
  subTotal: "subTotal",
  nested: "nested",
  finance: "finance",
  deposit: "deposit",
};

export const DISCOUNT_TYPES = {
  price: "Price",
  percent: "Percent"
};

export const DISCOUNT_MODES = {
  and: "And",
  or: "Or"
};

export const DISCOUNT_SECTION_TYPES = {
  default: "default",
  finance: "finance"
};

export const DISCOUNT_FINANCE_CELLS = {
  financePercentage: "Finance Percentage",
  financeMonths: "Months",
  financeSalesPercentage: "Sales Person Percentage",
}

export const DISCOUNT_DYNAMIC_PROPERTIES = ["selected", "type", "name", "amount", "financeOptions", "approveOptions"];

export const discountInterFace = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  order: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  enabled: PropTypes.bool.isRequired,
  type: PropTypes.oneOf([DISCOUNT_TYPES.price, DISCOUNT_TYPES.percent]).isRequired,
  mode: PropTypes.oneOf([DISCOUNT_MODES.and, DISCOUNT_MODES.or]).isRequired,
  amount: PropTypes.number.isRequired,
  isRidged: PropTypes.bool.isRequired,
  isSubTotal: PropTypes.bool,
  selected: PropTypes.bool,  // it is not required, since it is not stored on the backend
  // specialVisible: PropTypes.bool,  // it is not required, since it is not stored on the backend // we don't have it anymore
  uuId: PropTypes.string, // for new added nested
  nestedParent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  discountType: PropTypes.oneOf(Object.keys(DISCOUNT_MAIN_TYPES)),
  financePercentage: PropTypes.number,
  financeMonths: PropTypes.number,
  financeSalesPercentage: PropTypes.number,
  financeOptions: PropTypes.string, // "[12345, 12314, 1233]" JSON
  multiSelections: PropTypes.bool,
  approveOptions: PropTypes.string, // "['Some Name', 'Another Name']"
  roomValues: PropTypes.object, // {"0": {...DISCOUNT_DYNAMIC_PROPERTIES}, "1": {...DISCOUNT_DYNAMIC_PROPERTIES}}
  defaultValues: PropTypes.object, // {...DISCOUNT_DYNAMIC_PROPERTIES}
  quoteIndex: PropTypes.number, // // for new added nested // is used for custom only
};

export const discountSectionsInterface = {
  id: PropTypes.number.isRequired,
  order: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  discounts: PropTypes.arrayOf(PropTypes.shape(discountInterFace)),
  wizardLogic: PropTypes.string,
};

export const discountWizardLogicInterface = {
  index: PropTypes.number.isRequired,
  displayOptions: PropTypes.arrayOf(PropTypes.shape(discountWizardLogicDisplayOptionsInterface)),
};

export const discountWizardLogicDisplayOptionsInterface = {
  id: PropTypes.string,
  forVisualizer: PropTypes.string,
  forWizardId: PropTypes.number,
  forWizardHashId: PropTypes.string,
  forWizardName: PropTypes.string,
  forWizardGroupTitle: PropTypes.string,
  forWizardGroupId: PropTypes.string,
  forWizardGroupName: PropTypes.string,
};
